module.exports = __webpack_public_path__ + "media/images/konintodoke/banner/banner_dress-af22537bfbdd7e5b44b469f3ce0d6755.png";